var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.334 43.9987V53.9987C69.334 54.8828 68.9828 55.7306 68.3577 56.3557C67.7326 56.9808 66.8847 57.332 66.0007 57.332H12.6673C11.7833 57.332 10.9354 56.9808 10.3103 56.3557C9.68517 55.7306 9.33398 54.8828 9.33398 53.9987V20.6654C9.33398 19.7813 9.68517 18.9335 10.3103 18.3083C10.9354 17.6832 11.7833 17.332 12.6673 17.332H44.334",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6675 70.666H56.0008",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.334 57.332V70.6654",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.334 57.332V70.6654",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9174 13.9433L45.688 32.6899C45.4567 33.0909 45.3343 33.5454 45.333 34.0083C45.3318 34.4712 45.4517 34.9263 45.6809 35.3285C45.9101 35.7307 46.2406 36.0659 46.6395 36.3008C47.0384 36.5356 47.4918 36.662 47.9547 36.6673H70.4147C70.8776 36.662 71.331 36.5356 71.7299 36.3008C72.1288 36.0659 72.4593 35.7307 72.6885 35.3285C72.9177 34.9263 73.0376 34.4712 73.0364 34.0083C73.0351 33.5454 72.9127 33.0909 72.6814 32.6899L61.4507 13.9433C61.2142 13.5539 60.8814 13.232 60.4844 13.0087C60.0874 12.7853 59.6396 12.668 59.184 12.668C58.7285 12.668 58.2806 12.7853 57.8836 13.0087C57.4866 13.232 57.1538 13.5539 56.9174 13.9433Z",
    fill: "#ECE8F5",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3335 20.668V28.5",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3335 32V32.0333",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMonitor);
export default __webpack_public_path__ + "static/media/error_monitor.6f5dcc9a17e54ce6dcfa1426b5118b4f.svg";
export { ForwardRef as ReactComponent };